import { useState } from 'react';
import {
  UploadInspectionDataModalContext,
  UploadInspectionDataModalContextErrorState,
} from './UploadInspectionDataModalContext';

interface UploadInspectionDataModalContextProviderProps {
  children: React.ReactNode;
}

export function UploadInspectionDataModalContextProvider({
  children,
}: UploadInspectionDataModalContextProviderProps) {
  const [alertState, setAlertState] = useState<UploadInspectionDataModalContextErrorState | null>(
    null
  );

  const contextValue = {
    alertState,
    setAlertState,
  };

  return (
    <UploadInspectionDataModalContext.Provider value={contextValue}>
      {children}
    </UploadInspectionDataModalContext.Provider>
  );
}
